/**
 * useBoardsEntryScreen.js
 * -----------------------
 * Hook for Boards create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as boardsApi from '../api/boardsApi';

export function useBoardsEntryScreen() {
  return useMasterEntry({
    entityName: 'Board',
    apiClient: boardsApi.boardsClient,
    fetchDetail: boardsApi.getBoardDetail,
    createItem: boardsApi.createBoard,
    updateItem: boardsApi.updateBoard,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Board Name is required.';
      }
      return null;
    },
    listPath: '/masters/boards/list',
  });
}
